import React, { Component } from 'react';
import PropTypes from 'prop-types';
import throttle from 'lodash/throttle';

import Message from './message';

class StickySubmit extends Component {
  constructor() {
    super();

    this.state = {
      fixFooter: false
    };
  }

  componentDidMount() {
    this.handleScroll = throttle(this.handleScroll.bind(this), 100);
    window.addEventListener('scroll', this.handleScroll);
  }

  handleScroll() {
    if (
      window.innerHeight + window.scrollY < document.body.offsetHeight - 200 &&
      this.state.fixFooter
    ) {
      this.setState({ fixFooter: false });
    }

    if (
      window.innerHeight + window.scrollY >=
      document.body.offsetHeight - 100
    ) {
      this.setState({ fixFooter: true });
    }
  }

  render() {
    return (
      <div
        className={`sticky-submit ${
          this.state.fixFooter ? 'sticky-submit--static' : ''
        }`}
      >
        <div className="sticky-submit__button-container">
          <button
            className="sticky-submit__button"
            type="submit"
            onClick={this.props.handleSubmit}
          >
            Update Preferences
          </button>
        </div>
        <div className="sticky-submit__message-container">
          <Message type="success" message={this.props.message} />
        </div>
      </div>
    );
  }
}

StickySubmit.defaultProps = {
  message: ''
};

StickySubmit.propTypes = {
  message: PropTypes.string,
  handleSubmit: PropTypes.func.isRequired
};

export default StickySubmit;
